/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsSubsidyDtoPrice
 */
export interface JpCoBenefitoneBsSubsidyDtoPrice {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoPrice
     */
    subsidyPriceId?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoPrice
     */
    subsidyDetailId?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoPrice
     */
    priceType?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoPrice
     */
    limApplicableDateFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoPrice
     */
    limApplicableDateTo?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsSubsidyDtoPrice
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoPrice
     */
    ageType?: string;
}

export function JpCoBenefitoneBsSubsidyDtoPriceFromJSON(json: any): JpCoBenefitoneBsSubsidyDtoPrice {
    return JpCoBenefitoneBsSubsidyDtoPriceFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsSubsidyDtoPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsSubsidyDtoPrice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subsidyPriceId': !exists(json, 'subsidyPriceId') ? undefined : json['subsidyPriceId'],
        'subsidyDetailId': !exists(json, 'subsidyDetailId') ? undefined : json['subsidyDetailId'],
        'priceType': !exists(json, 'priceType') ? undefined : json['priceType'],
        'limApplicableDateFrom': !exists(json, 'limApplicableDateFrom') ? undefined : json['limApplicableDateFrom'],
        'limApplicableDateTo': !exists(json, 'limApplicableDateTo') ? undefined : json['limApplicableDateTo'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'ageType': !exists(json, 'ageType') ? undefined : json['ageType'],
    };
}

export function JpCoBenefitoneBsSubsidyDtoPriceToJSON(value?: JpCoBenefitoneBsSubsidyDtoPrice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subsidyPriceId': value.subsidyPriceId,
        'subsidyDetailId': value.subsidyDetailId,
        'priceType': value.priceType,
        'limApplicableDateFrom': value.limApplicableDateFrom,
        'limApplicableDateTo': value.limApplicableDateTo,
        'price': value.price,
        'ageType': value.ageType,
    };
}

